import React from "react";
import PropTypes from "prop-types";
import { PlusOutlineGradientIcon } from "wm-graphics";
import { Tooltip } from "../../../Tooltip";
import "./AddTabButton.scss";

const ENTER_KEY = "Enter";

export class AddTabButton extends React.Component {
  static propTypes = {
    onClick: PropTypes.func,
    addTabToolTip: PropTypes.string,
  };

  onKeyDown = (event) => {
    const { onClick } = this.props;

    if (event.key === ENTER_KEY) {
      onClick();
    }
  };

  render() {
    const { addTabToolTip, onClick } = this.props;

    return (
      <Tooltip content={addTabToolTip}>
        <div
          className="AddTabButton"
          data-testid="AddTabButton"
          onClick={onClick}
          onKeyDown={this.onKeyDown}
          role="button"
          tabIndex={0}
        >
          <PlusOutlineGradientIcon />
        </div>
      </Tooltip>
    );
  }
}

export default AddTabButton;
